const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBoxCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 0A14.98 14.98 0 0 0 0 15a15.089 15.089 0 0 0 14.9 15h.2A15 15 0 0 0 15 0zm-1.8 20.3a1.606 1.606 0 0 1-1.1.5 1.606 1.606 0 0 1-1.1-.5l-4.2-4.4.8-.8 4.2 4.3a.5.5 0 0 0 .6 0L22.5 9.2l.8.8z",
    style: {
      fill: "#009ee3"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxCheckIcon);
export default __webpack_public_path__ + "static/media/checkBoxCheckIcon.eb18d41bdb9768b711af987d16e8bd1b.svg";
export { ForwardRef as ReactComponent };